import PropTypes from "prop-types";
import styled from "styled-components/macro";

const statusColours = {
  complete: "var(--juno-status-color-complete)",
  started: "var(--juno-status-color-started)",
  not_started: "var(--juno-status-color-not-started)",
};

function StatusUpdateTitle({ type = "generic", status, children }) {
  return (
    <Title type={type} status={status}>
      {children}
    </Title>
  );
}

export default StatusUpdateTitle;

StatusUpdateTitle.propTypes = {
  status: PropTypes.string.isRequired,
  type: PropTypes.string,
};

const Title = styled.h3`
  color: ${({ status }) => statusColours[status]};
  font-size: 1rem;
  line-height: 1.5;
  margin-top: 0;
  margin-bottom: ${({ type }) => (type === "generic" ? "var(--juno-space-4)" : 0)};
  font-weight: var(--juno-font-weight-bold);
`;
